export default __webpack_public_path__ + "static/kariera-5295f77122ad2058e3befeb38ca34fd6.png";